import M from "materialize-css";
import { LocaleCode } from "../../typings/lang";
import { onlineT } from "../../typings/online";
import { Enums } from "../../thor.enums";

export class OnlineItemBaseController {
    public static $inject: string[] = [
        "$element",
        "$scope",
        "categoryService",
        "mediaGalleryService",
        "onlineItemEdit"
    ];

    // binded
    protected item: onlineT.Item;
    protected isItemEdited: boolean;
    protected readOnly: boolean = true;
    protected saleCurrency: Enums.Currency;
    protected selectedLang: LocaleCode;

    protected inView: boolean;

    constructor(
        protected $element,
        protected $scope: ng.IScope,
        protected categoryService,
        protected mediaGalleryService,
        protected onlineItemEdit
    ) {}

    public showGallery() {
        this.mediaGalleryService.open(this.item, "gallery", !this.isItemEdited && this.readOnly);
    }

    protected _watchInView() {
        this.$scope.$watch(
            () => this.item.inView,
            (isCardInViewport: boolean) => {
                if (isCardInViewport) {
                    this.inView = isCardInViewport;

                    angular.element(() => {
                        const dropdown = this.$element[0].querySelector(".dropdown-trigger");
                        if (dropdown) {
                            M.Dropdown?.init(dropdown, { constrainWidth: false });
                        }
                    });
                }
            }
        );
    }
}
